/**
 * Transaction Service
 * 거래 관련 모든 API 호출을 중앙화
 */

import { apiClient } from './apiClient';

class TransactionService {
  /**
   * 거래 목록 조회
   * @returns {Promise<Array>} 거래 내역 배열
   */
  async getTransactions() {
    return apiClient.get('/api/transactions');
  }

  /**
   * 거래 생성
   * @param {object} data - 거래 데이터 (type, amount, category, description, date 등)
   * @returns {Promise<object>} 생성된 거래 데이터
   */
  async createTransaction(data) {
    return apiClient.post('/api/transactions', data);
  }

  /**
   * 거래 수정
   * @param {number} id - 수정할 거래 ID
   * @param {object} data - 수정할 거래 데이터
   * @returns {Promise<object>} 수정된 거래 데이터
   */
  async updateTransaction(id, data) {
    return apiClient.put(`/api/transactions/${id}`, data);
  }

  /**
   * 거래 삭제
   * @param {number} id - 삭제할 거래 ID
   * @returns {Promise<void>}
   */
  async deleteTransaction(id) {
    return apiClient.delete(`/api/transactions/${id}`);
  }

  /**
   * 거래 검색
   * @param {object} query - 검색 파라미터 (type, category, startDate, endDate, minAmount, maxAmount, description)
   * @returns {Promise<Array>} 검색 결과 거래 배열
   */
  async searchTransactions(query) {
    return apiClient.get('/api/transactions/search', { params: query });
  }
}

export const transactionService = new TransactionService();
export default transactionService;
